/** PURE_IMPORTS_START .._.._Observable,.._.._operator_mergeMapTo PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { mergeMapTo } from '../../operator/mergeMapTo';
Observable.prototype.flatMapTo = mergeMapTo;
Observable.prototype.mergeMapTo = mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/mergeMapTo.js
// module id = ./node_modules/rxjs/_esm5/add/operator/mergeMapTo.js
// module chunks = vendor